import { vysionService } from '../utils/vysion/vysionService';
import { convertSentanceTitleCase, removeFirstWord } from '../utils/helpers';
import { BillingReturnType, EventTypeProp, SetBillingAction } from './types/billingTrackAction';

const setBillingAction = (eventType: EventTypeProp): SetBillingAction => {
  return {
    type: 'BILLING',
    payload: {
      event: eventType,
      eventData: {
        action: 'click',
        page: 'Billing',
        extraInfo: setExtraInfo(eventType),
        component: setComponent(eventType),
      },
      userData: null,
      deviceData: null,
      extendedData: null,
    },
  };
};

const setExtraInfo = (eventType: EventTypeProp): BillingReturnType => {
  switch (eventType) {
    case 'SOFORT FIRST NAME':
    case 'SOFORT LAST NAME':
    case 'SOFORT COUNTRY':
      return convertSentanceTitleCase(removeFirstWord(eventType));
    default:
      return null;
  }
};

const setComponent = (eventType: EventTypeProp): BillingReturnType => {
  switch (eventType) {
    case 'SOFORT FIRST NAME':
    case 'SOFORT LAST NAME':
    case 'SOFORT COUNTRY':
      return 'Sofort';
    default:
      return null;
  }
};

const billingSofortFirstName = (): void => {
  vysionService(setBillingAction('SOFORT FIRST NAME'));
};

const billingSofortLastName = (): void => {
  vysionService(setBillingAction('SOFORT LAST NAME'));
};

const billingSofortCountry = (): void => {
  vysionService(setBillingAction('SOFORT COUNTRY'));
};

export { billingSofortFirstName, billingSofortLastName, billingSofortCountry };
